(ns shared.core.amelia-light.components.badge
  (:require ["@up/base-ui/components/ui/badge" :refer [Badge]]))

(defn up-badge [args & children]
  (into [:> Badge args] children))
